export default "__VITE_ASSET__V5C6Munw__"